import { loader } from "@monaco-editor/react";
import type { editor, Position } from "monaco-editor";

// TODO: remove this once @stedi/dls is upgraded beyond 3.31.3 (this release includes the same path configuration)
loader.config({
  paths: { vs: "https://cdn.jsdelivr.net/npm/monaco-editor@0.34.1/min/vs" },
});

// When a user has a cursor (defined by `position`) in the middle of a word - in most cases we want to get the whole "current word"
// for further processing as part of the autocomplete logic, that's why we are using `getWordAtPosition`
// and only if it returns `null` we fall back to `getWordUntilPosition` which is returning the word only up until the current `position`
// and is guaranteed to return at some word, even if empty.
export const getWordAtOrUntilPosition = (model: editor.ITextModel, position: Position): editor.IWordAtPosition => {
  const wordAtCurrentPosition = model.getWordAtPosition(position);
  if (wordAtCurrentPosition) {
    return wordAtCurrentPosition;
  }

  return model.getWordUntilPosition(position);
};
